import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";


@Injectable()
export class LaunchpadService {
    public window: any = window;
    public banner = this.window['AB']?.userInfo?.banner;
    private HTTP_OPTIONS = { headers: new HttpHeaders(this.window['AB']?.j4uHttpOptions) };

    constructor(public http: HttpClient) { }

    init() {
        this.banner = this.window['AB'].userInfo.banner;
        this.HTTP_OPTIONS = { headers: new HttpHeaders(this.window['AB'].j4uHttpOptions) };
    }

    public getLaunchpadData() {
        const wwwHost = this.window['SWY'].CONFIGSERVICE.bannerDomainMap["www-" + this.banner];
        const url = `${wwwHost}/content/dam/data/b4u-content/launchpadcontent.json`;
        const headers = new HttpHeaders().set('X-Service-Name', 'LaunchpadService').set('X-Function-Name', 'getLaunchpadData');
        return this.http.get(url, { headers }).pipe(
            map((data: any) => {
                return data;
            })
        )
    }

    public getLifetimeSavingsData() {
        const wwwHost = this.window['SWY'].CONFIGSERVICE.bannerDomainMap["www-" + this.banner];
        const apiPath = this.window['AB'].savingsAPIPath;
        const url = `${wwwHost}${apiPath}`;
        // Clone HTTP_OPTIONS and append additional headers
        const modifiedHttpOptions = {
            ...this.HTTP_OPTIONS,
            headers: this.HTTP_OPTIONS.headers
                .set('X-Service-Name', 'LaunchpadService')
                .set('X-Function-Name', 'getLifetimeSavingsData')
        };
        return this.http.get(url, modifiedHttpOptions).pipe(
            map((data: any) => {
                return data;
            }, catchError(this.handleError))
        )
    }

    public getRewardsPointsBalance() {
        const wwwHost = this.window['SWY'].CONFIGSERVICE.bannerDomainMap["www-" + this.banner];
        const apiPath = this.window['AB'].ocrpRewardScorecard;
        const url = `${wwwHost}${apiPath}`;
        const httpOptions = {
            headers: new HttpHeaders(this.window['AB'].xAPIOcrpRewardsHttpOptionsV3)
                .set('X-Service-Name', 'LaunchpadService')
                .set('X-Function-Name', 'getRewardsPointsBalance')
        };
        const body = {
            hhid: this.window['AB'].userInfo.houseId,
            programType: ['BASEPOINTS']
        }
        let rewardBalance: number = 0;
        return this.http.post(url, body, httpOptions).pipe(
            map((data: any) => {
                if (data && data['scorecards'] && data['scorecards'].length) {
                    data['scorecards'].forEach((scorecard: any) => {
                        if (scorecard && scorecard['programType'] === 'BASEPOINTS') {
                            rewardBalance = scorecard['balance'];
                        }
                    })
                }
                return rewardBalance;
            }, catchError(this.handleError))
        )
    }

    public handleError(errorResponse: HttpErrorResponse) {
        if (!(errorResponse.error instanceof ErrorEvent) && errorResponse.error) {
            console.error(`status: ${errorResponse.status}, ${errorResponse.statusText}`);
            const errCode = errorResponse.error.code && errorResponse.error.message ? errorResponse.error.code : errorResponse.status;
            return throwError(errCode);
        }
        return throwError(errorResponse.error); // Add this line to return a value in case the condition is not met
    }

}
